export function formatTimeAsString (date?: number): string {
  if (!date) return ''

  const dateObj = new Date(date)
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false // Ensures 24-hour format
  }

  return dateObj.toLocaleTimeString('de-DE', options)
}
